import React, { useRef } from "react";
import HowItWorks from "@components/sections/HowItWorks";
import { CtaBanner } from "@components/sections/CtaBanner";
import { HeroSlider } from "@components/sections/HeroSlider";
import { RaffleSlider } from "@components/sections/RaffleSlider";
import { config } from "config";
import { useNavigate } from "react-router-dom";
import { RaffleAdvertising } from "@components/sections/RafflePromoSection";

export const Land: React.FC = () => {
  const navigate = useNavigate();
  const howItWorksRef = useRef<HTMLDivElement>(null);

  const scrollToHowItWorks = () => {
    howItWorksRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      {/* 1. Hero with featured raffle + stats */}
      <HeroSlider onHowItWorksClick={scrollToHowItWorks} />

      {/* 2. Latest raffle campaigns - horizontal scroll */}
      <RaffleSlider />

      <RaffleAdvertising
        onCreateRaffle={() => {
          window.open(config.urls.panel, "_blank");
        }}
      />

      {/* 3. How it works - 3 steps */}
      <div ref={howItWorksRef}>
        <HowItWorks />
      </div>

      {/* 4. Winners & testimonials slider */}
      {/* <WinnersSlider /> */}

      {/* 5. Seller CTA banner */}
      <CtaBanner />
    </>
  );
};
